import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from "primeng/dynamicdialog";
import { JobInsertRequest } from "../../shared/job-insert-request";
import * as moment from "moment";
import { RiJobAddUsersComponent } from "./ri-job-add-users/ri-job-add-users.component";
import { DataService_ScheduledJobs } from "../../shared/data.service";
import { StringRequest } from "../../shared/string-request";

@Component({
	selector: "app-ri-job-add",
	templateUrl: "./ri-job-add.component.html",
	styleUrls: ["./ri-job-add.component.css"],
})
export class RiJobAddComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		private dataService: DataService_ScheduledJobs
	) {}

	ngOnInit(): void {
		this.loadReportScripts();
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////

	JobDesc: string = "";

	SelectedReportScript: any;
	lstReportScript: any = [];
	LoadingReportScript: boolean = false;
	LoadingParameters: boolean = false;

	RunTime: Date = new Date();
	RunMon: boolean = true;
	RunTue: boolean = true;
	RunWed: boolean = true;
	RunThu: boolean = true;
	RunFri: boolean = true;
	RunSat: boolean = false;
	RunSun: boolean = false;

	pagerows: any = 10;
	pagefirst: any = 0;
	lstUsers: any = [];
	SelectedUsers: any = [];
	cols: any = [
		{ field: "Username", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
	];

	Processing: boolean = false;
	errorMessage: string = "";

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////

	loadReportScripts() {
		this.LoadingReportScript = true;

		var result = this.dataService.ReportScriptsSelectList();
		result.subscribe(
			(response) => {
				this.lstReportScript = response;

				for (var z = 0; z < this.lstReportScript.length; z++) {
					var rs = this.lstReportScript[z];

					for (var x = 0; x < rs.lstParameters.length; x++) {
						var p = rs.lstParameters[x];

						p.UseList = false;
						p.lstOptions = [];
					}
				}

				this.onSelectedReportScript(this.lstReportScript[0]);

				this.LoadingReportScript = false;
			},
			(error) => {
				this.LoadingReportScript = false;
			}
		);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onAddUser() {
		this.errorMessage = "";
		this.SelectedUsers = [];

		var ref = this.dialogService.open(RiJobAddUsersComponent, {
			header: "Add Users",
			width: "fit-content",
			data: {
				SelectedUsers: this.lstUsers,
			},
		});
		ref.onClose.subscribe((response: any) => {
			if (response.Success != undefined && response.Success == true) {
				this.lstUsers = response.lstUsers;
			}
		});
	}

	onRemoveUser() {
		this.lstUsers = this.lstUsers.filter((user) => this.SelectedUsers.indexOf(user) == -1);
		this.SelectedUsers = [];
	}

	onAdd() {
		this.errorMessage = "";

		if (this.JobDesc == "") {
			this.errorMessage = "Enter name/description of the job";
			return;
		}

		if (this.SelectedReportScript.ReportScriptID <= 0) {
			this.errorMessage = "Select which report to generate";
			return;
		}

		var fDate = moment(this.RunTime).format("HH:mm:00");

		if (String(fDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Run Time";
			return;
		}

		if (
			this.RunMon == false &&
			this.RunTue == false &&
			this.RunWed == false &&
			this.RunThu == false &&
			this.RunFri == false &&
			this.RunSat == false &&
			this.RunSun == false
		) {
			this.errorMessage = "Select which day(s) the report should get generated";
			return;
		}

		var lstUID = this.lstUsers.map((user) => user.UserID);

		if (lstUID == undefined || lstUID.length == 0) {
			this.errorMessage = "Add Users to send the report to";
			return;
		}

		var lstParmIDs: number[] = [];
		var lstParmValues: string[] = [];

		if (this.SelectedReportScript.lstParameters != undefined && this.SelectedReportScript.lstParameters.length > 0) {
			lstParmIDs = this.SelectedReportScript.lstParameters.map((item) => item.ParameterID);
			lstParmValues = this.SelectedReportScript.lstParameters.map((item) => item.ParameterValue);
		}

		var parms: JobInsertRequest = {
			JobDesc: this.JobDesc,
			ReportScriptID: this.SelectedReportScript.ReportScriptID,
			RunTime: fDate,
			RunMon: this.RunMon,
			RunTue: this.RunTue,
			RunWed: this.RunWed,
			RunThu: this.RunThu,
			RunFri: this.RunFri,
			RunSat: this.RunSat,
			RunSun: this.RunSun,
			lstReceipient: lstUID,
			lstParameterID: lstParmIDs,
			lstParameterValue: lstParmValues,
		};

		this.Processing = true;

		var result = this.dataService.JobInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "addjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Job was created successfully. When the job runs you will be able to see the results from your inbox.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "addjob",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the job: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////

	onSelectedReportScript(val) {
		this.SelectedReportScript = val;

		if (this.SelectedReportScript.lstParameters != undefined && this.SelectedReportScript.lstParameters.length > 0) {
			this.loadParameters();
		}
	}

	loadParameters() {
		this.LoadingParameters = true;

		for (var z = 0; z < this.SelectedReportScript.lstParameters.length; z++) {
			var next = this.SelectedReportScript.lstParameters[z];

			if (next.ParameterOptions != undefined && next.ParameterOptions != "") {
				next.UseList = true;
				next.lstOptions = [];

				if (next.ParameterOptions.indexOf("|") > 0) {
					next.lstOptions = [];

					var lstTemp = next.ParameterOptions.split("|");

					for (var x = 0; x < lstTemp.length; x++) {
						var nextTemp = lstTemp[x];
						var nextOption = {
							ID: nextTemp,
							Desc: nextTemp,
						};

						next.lstOptions = [...next.lstOptions, nextOption];
					}

					next.ParameterValue = next.lstOptions[0].ID;
				} else {
					this.ReportScriptOptionSelectList(next);
				}
			} else {
				next.UseList = false;
			}
		}

		this.LoadingParameters = false;
	}

	ReportScriptOptionSelectList(parameter: any) {
		var parms: StringRequest = {
			str: parameter.ParameterOptions,
		};

		var result = this.dataService.ReportScriptOptionSelectList(parms);
		result.subscribe(
			(response: any) => {
				parameter.lstOptions = response;
				parameter.ParameterValue = parameter.lstOptions[0].ID;
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingReportScript == true || this.LoadingParameters == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////
}
